<template>
  <div class="asc-input-field--container asc-input-field--container-textarea">
    <v-textarea
      v-model="model"
      v-bind="getSharedAttrs"
      :auto-grow="true"
      :rows="rows"
      :no-resize="noResize"
      :row-height="rowHeight"
      :flat="noUnderline"
      :solo="noUnderline"
      @blur="handleBlur"
      @focus="focus = true"
    >
      <template v-if="label" #label>
        <asc-required-label
          :label="label"
          :required="required && requiredVisible"
        />
      </template>
      <template v-if="hasCounter" #counter="{ props }">
        <v-counter v-bind="props" :value="getCounterValue"></v-counter>
      </template>
    </v-textarea>
  </div>
</template>

<script>
import { AscInputMixin } from '@/components/mixins'

export default {
  name: 'AscTextareaInput',

  mixins: [AscInputMixin],

  props: {
    autogrow: {
      type: Boolean,
      default: true,
    },
    rows: {
      type: Number,
      default: 1,
    },
    noResize: {
      type: Boolean,
      default: false,
    },
    rowHeight: {
      type: Number,
      default: 24,
    },
    noUnderline: {
      type: Boolean, // for underline removal
      default: false,
    },
  },
}
</script>

<style lang="scss">
.v-textarea .v-text-field__prefix,
.v-textarea .v-text-field__suffix {
  padding-top: 6px;
}
</style>
